import { useGetSelfFundingMandateFormQuery } from 'src/shared/api/company';
import { useGetUserHoldingQuery } from 'src/shared/api/holding';
import { type Company } from 'src/shared/types/company';

export const useAutomaticInformation = (selectedCompanyId: string) => {
  const { data: holding } = useGetUserHoldingQuery();
  const calculationDay = holding?.settings?.cycles?.cycles[0]?.calculationDay ?? '';
  const companyData = holding?.companies.find((company: Company) => company.id === selectedCompanyId);
  const { selfFundingDirectDebitIban } = companyData?.metadata?.billing ?? {};
  const { data: mandateData } = useGetSelfFundingMandateFormQuery(companyData?.taxIdentifier ?? '', {
    skip: !selfFundingDirectDebitIban
  });

  return { mandateData, selfFundingDirectDebitIban, calculationDay };
};
